export default {
  async getExistingIntegrations(axios, vonageStore, token) {
    let response = await axios.get('/api/vonage/vonage-integrations/', {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
    response.data.data.forEach(integration => {
      vonageStore.replaceOrAdd(integration);
    });
  },
};
